<template>
  <div class="app-container">
    <el-card class="box-card">
      <div class="filter-container">
        <el-form :model="query" ref="queryForm" :inline="true">
          <el-form-item label="治疗师手机号码：" prop="pho">
            <el-input v-model="query.pho" placeholder="请输入手机号" size="small" />
          </el-form-item>
          <el-form-item label="治疗师身份：">
            <el-select v-model="query.levelId" placeholder="请选择" clearable size="small">
              <el-option label="研修班" :value="6"></el-option>
              <el-option label="体验班" :value="7"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="标题：" prop="storeName">
            <el-input v-model="query.storeName" placeholder="请输入标题" size="small" />
          </el-form-item>
          <el-form-item label="时间筛选：">
            <el-date-picker v-model="dateTime" size="small" type="datetimerange" value-format="yyyy-MM-dd HH:mm:ss" start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
          </el-form-item>
          <el-form-item class="fr">
            <el-button type="primary" @click="handleQuery" size="mini">搜索</el-button>
            <el-button type="info" @click="handleFilter" plain size="mini">重置</el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-card>
    <el-card class="box-card mt10">
      <el-table v-loading="listLoading" :data="list" @selection-change="selectionChange" @sort-change="sortChange">
        <!-- <el-table-column type="selection" width="50" /> -->
        <el-table-column label="治疗师姓名" prop="customerName" align="center" />
        <el-table-column label="身份" prop="customerLevel" align="center" />
        <el-table-column label="手机号码" prop="customerPho" align="center" />
        <el-table-column label="标题" prop="storeName" align="center" />
        <el-table-column label="发布时间" prop="createdTime" align="center" />
        <el-table-column label="发送C端用户人数" prop="sendAppNum" align="center" />
        <el-table-column label="查看人数" prop="lookNum" align="center" />
        <el-table-column label="浏览次数" prop="browseNum" align="center" />
        <el-table-column label="操作" align="center" fixed="right" width="130">
          <template slot-scope="{row}">
            <el-button type="text" @click="handleShow(row)">详情</el-button>
          </template>
        </el-table-column>
      </el-table>
      <pagination v-show="total>0" :total="total" :pageNo.sync="query.pageNo" :pageSize.sync="query.pageSize" @pagination="doQueryList" />
    </el-card>
  </div>
</template>

<script>
import userStoreApi from '@/api/archives/userStore'
import Pagination from '@/components/Pagination'

export default {
  components: {
    Pagination,
  },
  data() {
    return {
      list: [],
      total: 0,
      listLoading: true,
      query: {
        pageNo: 1,
        pageSize: 10
      },
      selectItems: [],
      dateTime: null
    }
  },
  created() {
    this.doQueryList({ pageNo: 1 })
  },
  methods: {
    handleFilter() {
      this.query = {}
      this.dateTime = []
      this.doQueryList({ pageNo: 1, pageSize: 10 })
    },
    /**
     * 选择框变化
     */
    selectionChange(val) {
      this.selectItems = val
    },
    /**
     * 触发后端排序
     */
    sortChange({ prop, order }) {
      const sortKeyMap = {
        'createdTime': 'createdTimeSortSign',
        'operatedTime': 'operatedTimeSortSign'
      }
      for (var k in sortKeyMap) {
        const sortKey = sortKeyMap[k]
        if (k !== prop) {
          this.query[sortKey] = null
        } else {
          if (order === 'ascending') {
            this.query[sortKey] = 1
          } else {
            this.query[sortKey] = -1
          }
        }
      }
      this.doQueryList({})
    },
    /**
     * 分类筛选
     */
    handleClick() {
      this.doQueryList({ pageNo: 1 })
    },
    /**
     * 触发搜索操作
     */
    handleQuery() {
      this.doQueryList({ pageNo: 1 })
    },
    /**
     * 执行列表查询
     */
    doQueryList({ pageNo, pageSize }) {
      if (pageNo) {
        this.query.pageNo = pageNo
      }
      if (pageSize) {
        this.query.pageSize = pageSize
      }
      let query = { ...this.query }
      query.startTime = this.dateTime && this.dateTime.length > 0 ? this.dateTime[0] : undefined
      query.endTime = this.dateTime && this.dateTime.length > 0 ? this.dateTime[1] : undefined
      query.dataType = 2
      this.listLoading = true
      return userStoreApi.fetchList(query)
        .then(({ data }) => {
          console.log("data: ", data);
          this.list = data.list
          this.total = data.total
        })
        .finally(() => {
          this.listLoading = false
        })
    },
    /**
     * 删除单条记录
     */
    handleDeleteSingle(row) {
      return this.$common.confirm('是否确认删除')
        .then(() => userStoreApi.deleteById(row.id))
        .then(() => {
          this.$common.showMsg('success', '删除成功')
          return this.doQueryList({ pageNo: 1 })
        })
    },
    /**
     * 批量删除记录
     */
    handleDeleteBatch() {
      if (this.selectItems.length <= 0) {
        this.$common.showMsg('warning', '请选择数据')
        return
      }
      return this.$common.confirm(`当前选择${this.selectItems.length}条数据，是否确认删除`)
        .then(() => userStoreApi.deleteBatch(this.selectItems.map(row => row.id)))
        .then(() => {
          this.$common.showMsg('success', '删除成功')
          return this.doQueryList({ pageNo: 1 })
        })
    },
    /**
     * 打开查看表单
     */
    handleShow(row) {
      this.$emit('handleShow', row, 2)
    },
  }
}
</script>
